export const FilterTypes = {
    DROPDOWN: "DROPDOWN",
    DATE: "DATE"
};